module.exports = "/assets/site/images/calendar.svg?c3132aa022b1258f69a77a69735cd1f9";